import { memo, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { MenuOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';

import { getMainPath } from '@/shared/constants/router';
import { useMobileMenu } from '@/shared/lib/hooks';
import { FullLogo } from '@/shared/ui/logo';

import { AppMenu } from '../../menu/app-menu/app-menu';

import cls from './app-mobile-sider.module.css';

export const AppMobileSider = memo(() => {
    const { isOpen, setIsOpen } = useMobileMenu();

    const showDrawer = () => {
        setIsOpen(true);
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const { pathname } = useLocation();

    const isMainPath = useMemo(() => pathname === getMainPath(), [pathname]);

    return (
        <>
            <Button
                className={cls.triggerButton}
                disabled={isMainPath}
                icon={<MenuOutlined />}
                onClick={showDrawer}
                type="text"
            />
            <Drawer
                closable={false}
                onClose={onClose}
                open={isOpen}
                placement="left"
                rootClassName={cls.root}
                title={<FullLogo className={cls.logo} />}
                width={272}
            >
                <AppMenu
                    data-tour="app-menu"
                    isMobile
                    onClose={onClose}
                />
            </Drawer>
        </>
    );
});

AppMobileSider.displayName = 'AppMobileSider';
